// extracted by mini-css-extract-plugin
export var addressFields = "_mp-0";
export var animationContainer = "_mp-1";
export var footer = "_mp-2";
export var lineItems = "_mp-3";
export var modalContent = "_mp-4";
export var orderName = "_mp-5";
export var strong = "_mp-6";
export var warning = "_mp-7";